import React from 'react'
import { IItemModel } from './ItemsApp'
import { ISingleStatistic, SingleStatistic } from '../dashboard/Statistics'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import UnauthorizedBlock from '../../components/UnauthorizedBlock'

interface ISingleItemQuantityProps {
    item: IItemModel,
    usePublicDetails?: boolean,
}

export default function SingleItemQuantity(props: ISingleItemQuantityProps) {

    const { item, usePublicDetails } = props

    const items: ISingleStatistic[] = [
        {
            title: "Available",
            type: "total_warehouses",
            icon: "list",
            number: item.available_quantity
        },
        {
            title: "Reserved",
            type: "error",
            icon: "list",
            number: item.reserved
        },
        {
            title: "Damaged",
            type: "error",
            icon: "repair",
            number: item.damaged
        },
        {
            title: "Missing",
            type: "error",
            icon: "missing",
            number: item.missing
        }
    ]

    return(
        <SectionBoxContainer
            title="Quantity"
            showTitle
        >
            {usePublicDetails ? (
                <UnauthorizedBlock title="Unauthorized" message="You have to sign-in to your account in order to view the information." buttons={[ { label: "Sign-in", link: "/sign-in", color: "error" } ]} />
            ) : (
                <div className="statistics-container items-single-page">
                    <div className="content-of-statistics-container">
                        {items.map((item, index) => <SingleStatistic {...item} key={index} />)}
                    </div>
                </div>
            )}
        </SectionBoxContainer>
    )
}